import React from 'react';
import LoginContainer from '../containers/LoginContainer';

const LoginView = () => {
  return (
    <div>
      <LoginContainer/>
    </div>
  );
};

export default LoginView;
